// data.js
export const headerItems = [
  { id: 1, title: "Home", link: "/" },
  { id: 2, title: "About", link: "/about" },
  { id: 3, title: "Services", link: "/services" },
  { id: 4, title: "Project", link: "/project" },
  { id: 5, title: "Blog", link: "/blog" },
  { id: 6, title: "Contact", link: "/contact" },
];
